"use strict";
const constants_1 = require("./constants");
const helpers_1 = require("./helpers");
class Payment {
    _balance;
    interestRate;
    payment;
    constructor(options) {
        if (!options.balance || !options.interest || !options.payment) {
            throw new Error(constants_1.ERROR_MESSAGES.PAYMENT_OPTIONS_ERROR);
        }
        this._balance = options.balance;
        this.interestRate = options.interest;
        this.payment = options.payment;
    }
    get interest() {
        // (Total Amount Owed X Interest Rate) / 12 = Monthly Interest You Pay
        const interestRate = this.interestRate / 100;
        const monthlyAccruedInterest = (this._balance * interestRate) / 12;
        return (0, helpers_1.toCurrency)(monthlyAccruedInterest);
    }
    get balance() {
        let endPeriodBalance = this._balance - this.payment + this.interest;
        if (endPeriodBalance <= 0) {
            endPeriodBalance = 0;
        }
        return (0, helpers_1.toCurrency)(endPeriodBalance);
    }
}
module.exports = Payment;
